import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icona-fangxiangzhishiyou",
  "use": "icon-icona-fangxiangzhishiyou-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icona-fangxiangzhishiyou\"><path d=\"M601.216 512L356.864 756.352l54.272 54.336L709.824 512 411.136 213.312l-54.272 54.336L601.216 512z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol